import Hero from '../../assets/images/hero.png'
import ecom from '../../assets/images/ecom.png'


export default () => {
    return (
        <div className="m-2 card rounded-4">
            <div className="p-2" style={{ height: "250px" }}>
                <img src={ecom} className="w-100 h-100 rounded-4" />
            </div>
            <div className="p-3">
                <p className="bold mb-2">Lord Ganesh Brass Statue</p>
                <div className="d-flex align-items-center mb-4">
                    <p className="text-saffron me-3 x-bold fs-5 mb-0">₹250 <span className="text-muted x-bold text-decoration-line-through ms-2">₹200</span></p>
                    <span className="text-danger px-2 rounded-4 fs-9" style={{ backgroundColor: "rgb(241 174 181 / 54%)" }}>-20%</span>
                </div>

                <button className="search-button w-100">Add to cart</button>
            </div>
        </div>
    )
}